import styled from 'styled-components';

export const NewsletterSignupContainer = styled.div`
  position: relative;
  width: 100%;
  padding: var(--space-xxxxl) var(--space-m);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-l);
  overflow: hidden;
  background: radial-gradient(
      circle at top left,
      rgba(255, 210, 107, 0.18),
      transparent 34%
    ),
    radial-gradient(
      circle at bottom right,
      rgba(230, 139, 7, 0.12),
      transparent 32%
    ),
    linear-gradient(180deg, var(--grey0) 0%, var(--white) 100%);

  border-top: 1px solid rgba(15, 23, 42, 0.06);

  @media screen and (max-width: 600px) {
    padding: var(--space-xxxl) var(--space-m);
  }
`;

export const NewsletterInfo = styled.div`
  max-width: 720px;

  text-align: center;

  h3 {
    margin: var(--space-xs) 0 var(--space-m) 0;

    color: var(--grey7);

    font-size: clamp(2rem, 4vw, 3.2rem);
    line-height: 1.05;
    font-weight: 900;

    letter-spacing: -0.04em;
  }

  p:not(.eyebrowHeader) {
    max-width: 620px;

    margin: 0 auto;

    color: var(--grey4);

    font-size: 1rem;
    line-height: 1.8;
    font-weight: 500;
  }

  p span {
    display: block;

    margin-top: var(--space-xxxs);

    color: var(--grey3);

    font-size: var(--space-m);
    font-style: italic;
  }
`;

export const NewsletterForm = styled.form`
  display: flex;
  width: 100%;
  max-width: 680px;

  gap: var(--space-s);
  align-items: center;
  justify-content: center;

  input {
    flex: 1;

    padding: var(--space-s) var(--space-m);

    border-radius: ${({ theme }) => theme.borderRadius};

    border: 1px solid rgba(15, 23, 42, 0.12);

    font-size: var(--space-m);

    background: ${({ theme }) => theme.colors.white};

    transition:
      border-color 0.2s ease,
      box-shadow 0.2s ease;

    min-width: 0;

    &:focus {
      border-color: ${({ theme }) => theme.colors.orange4};
      outline: none;

      box-shadow: 0 0 0 4px rgba(242, 175, 23, 0.12);
    }
  }

  button {
    min-width: 120px;

    padding: var(--space-s) var(--space-m);

    border-radius: ${({ theme }) => theme.borderRadius};

    font-size: var(--space-m);
    font-weight: 700;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
    gap: var(--space-xs);

    input {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }

    button {
      width: 100%;
      min-width: 0;
    }
  }
`;

export const NewsletterStatus = styled.div`
  width: 100%;

  text-align: center;

  color: var(--infoBlue);

  font-size: var(--space-m);
  font-weight: 600;

  margin-top: var(--space-xs);
`;

export const NewsletterFinePrint = styled.span`
  text-align: center;

  color: var(--grey3);

  font-size: 0.85rem;
  line-height: 1.5;
  font-weight: 500;
  font-style: italic;
`;
